import React, { useRef, useContext } from 'react'
import { createUseStyles } from 'react-jss'
import { useSelector, shallowEqual } from 'react-redux'
import classNames from 'classnames'
// import useMouse from '@/hooks/useMouse'
import useUpdateEffect from '@/hooks/useUpdateEffect'
import usePrevious from '@/hooks/usePrevious'
import { Context } from '@/context'
import { Context as ScrollbarContext } from '@/context/scrollbar'
import style from './style'

const useStyles = createUseStyles(style)

const Spinner = () => {
  const { isFullscreenMode, setFullscreenMode, layout } = useContext(Context)
  const $progress = useRef()
  const classes = useStyles({ layout })
  const { setIsScrollBlock } = useContext(ScrollbarContext)
  const prevFullscreenMode = usePrevious(isFullscreenMode)

  /*------------------------------
  Redux Connect
  ------------------------------*/
  const { ready } = useSelector(state => ({
    mediaQueryKey: state.mediaQuery.key,
    ready: state.loading.ready,
  }), shallowEqual)

  const handleClickToClose = () => {
    setFullscreenMode(false)
  }

  useUpdateEffect(() => {
    if (!prevFullscreenMode && isFullscreenMode) {
      document.body.style.cursor = 'pointer'
      document.body.addEventListener('click', handleClickToClose)
    }
    if (prevFullscreenMode && !isFullscreenMode) {
      document.body.style.cursor = 'default'
      document.body.removeEventListener('click', handleClickToClose)
      setIsScrollBlock(false)
    }
  }, [isFullscreenMode])

  // useMouse(({ easeX, easeY }) => {
  //   if ($progress.current && mediaQueryKey > 2) {
  //     Object.assign($progress.current.style, {
  //       top: `${easeY}px`,
  //       left: `${easeX}px`,
  //     })
  //   }
  // })

  const renderProgress = () => {
    return (
      <div
        ref={$progress}
        className={classNames({
          [classes.spinner]: true,
          [classes.visible]: !ready,
        })}
      >
        <svg viewBox="0 0 50 50" className={classes.spinnerLoader}>
          <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="1" />
        </svg>
      </div>
    )
  }

  return renderProgress()
}

export default Spinner
